import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "./HowSearchWorks.css";
import HomeFooter from "./Home/HomeFooter";
import MainHeader from "./Main/MainHeader";

const steps = [
  {
    id: 1,
    title: "Step 1: Start with a Search",
    description:
      "The user types a search query on Anyworq to find relevant services. Enter your service category or keyword to begin.",
    img: "/images/step1.png",
  },
  {
    id: 2,
    title: "Step 2: Get Suggestions",
    description: "See relevant categories, services, and providers instantly.",
    img: "/images/scene2a.png",
  },
    {
    id: 3,
    title: "Step 3: Login or Sign Up",
    description: "Access personalized results by logging in or signing up.",
    img: "/images/scene3.png",
  },
  {
    id: 4,
    title: "Step 3a: Login ",
    description:
      "While clicking the checkbox you will become a service provider/dealer by logging.",
    img: "/images/scene3.png",
  },
  {
    id: 5,
    title: "Step 4: Save your Details",
    description: "If required Save your Details, Save your Time.",
    img: "/images/scene4a.png",
  },
  {
    id: 6,
    title: "Step 5: Explore Service",
    description:
      "Results are displayed instantly with accurate details. View detailed service providers.",
    imgs: [
      "/images/scene4a.png",
      "/images/scene4b.png",
      "/images/scene4c.png",
      "/images/scene4d.png",
      "/images/scene4e.png",
    ],
  },
  {
    id: 7,
    title: "Step 6: Click on View Details",
    description:
      "Results are displayed instantly with accurate details. View service providers details.",
    img: "/images/scene5a.png",
  },
  {
    id: 8,
    title: "Step 7: Sub Service Details",
    description: "Relavent to Main Service you will get details as you required.",
    img: "/images/scene5a.png",
  },
  {
    id: 9,
    title: "Step 8: Service Looking For",
    description:
      "Results are displayed instantly with accurate details. View detailed service providers and send quick enquiries.",
    img: "/images/scene5b.png",
  },
  {
    id: 10,
    title: "Step 9: Fill the Form Team Will Contact You ",
    description:
      "Fill all you details in that Pop Up form it will goes send quick enquiries then Our team Contact you.",
    img: "/images/scene6.png",
  },
];

export default function HowSearchWorks() {
  const [popupData, setPopupData] = useState({ img: null, stepId: null });
  const [carouselIndex, setCarouselIndex] = useState({});

  // Auto-rotate slides per step if step has multiple images
  useEffect(() => {
    const intervals = steps
      .filter((s) => s.imgs)
      .map((step) => {
        return setInterval(() => {
          setCarouselIndex((prev) => ({
            ...prev,
            [step.id]: prev[step.id] + 1 < step.imgs.length ? prev[step.id] + 1 : 0,
          }));
        }, 2000);
      });

    return () => intervals.forEach((i) => clearInterval(i));
  }, []);

  // Schema JSON-LD
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": "How Anyworq Search Works",
    "description":
      "Step-by-step guide explaining how to search and explore services on Anyworq.",
    "step": steps.map((s, i) => ({
      "@type": "HowToStep",
      "position": i + 1,
      "name": s.title,
      "text": s.description,
      ...(s.img ? { image: s.img } : s.imgs ? { image: s.imgs[0] } : {}),
    })),
  };

  const handleImageClick = (img, stepId) => {
    setPopupData({ img, stepId });
  };

  const closePopup = (e) => {
    if (e.target.classList.contains("popup-overlay") || e.target.classList.contains("popup-close")) {
      setPopupData({ img: null, stepId: null });
    }
  };

  return (
    <>
      <Helmet>
        <title>How Anyworq Search Works | Step-by-Step Guide</title>
        <meta
          name="description"
          content="Learn how Anyworq search works step by step – from starting a search, getting suggestions, exploring services, to contacting providers."
        />
        <meta
          name="keywords"
          content="Anyworq search, how it works, service marketplace, step by step guide, service providers, search services India"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>

      <MainHeader />
      <div className="how-search-works">
        <h1 className="page-title">How Anyworq Search Works</h1>
        <p className="subtitle">
          A step-by-step journey of how our smart search helps you connect faster.
        </p>

        <div className="steps-container">
          {steps.map((step, index) => (
            <div
              key={step.id}
              className={`step-card ${index % 2 === 0 ? "left" : "right"}`}
            >
              <div className="step-content">
                <h2>{step.title}</h2>
                <p>{step.description}</p>
              </div>
              <div className="step-image">
                {step.img && (
                  <img
                    src={step.img}
                    alt={step.title}
                    loading="lazy"
                    width="420"
                    height="260"
                    onClick={() => handleImageClick(step.img, step.id)}
                  />
                )}
                {step.imgs && (
                  <img
                    src={step.imgs[carouselIndex[step.id] || 0]}
                    alt={step.title}
                    loading="lazy"
                    width="420"
                    height="260"
                    onClick={() =>
                      handleImageClick(step.imgs[carouselIndex[step.id] || 0], step.id)
                    }
                  />
                )}
              </div>
            </div>
          ))}
        </div>

        {popupData.img && (
          <div className="popup-overlay" onClick={closePopup}>
            <span className="popup-close">&times;</span>
            <img
              src={popupData.img}
              alt="Step Preview"
              className="popup-img"
              loading="lazy"
            />
          </div>
        )}
      </div>
      <HomeFooter />
    </>
  );
}
